import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function completeAsana(asanasdata) {
  try {
    const response = await axiosInstance.post('asana/completeAsana', asanasdata);
    return response;
    
  } catch (error) {
    console.error(error);
    throw error;
  }
}
